<template>
  <div>
    <!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'信息漏斗'},{title:'目标对阵用户'}]" />-->
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">
                <!-- 结果展示 -->
                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                  <h1>目标对阵用户新增列表</h1>
                </div>
                <div class="h-pieceCon2" style="padding:0">
                <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                  <el-table
                      ref="multipleTable"
                      @selection-change="handleSelectionChange"
                      :data="tableData"
                      :border="true"
                      stripe
                      max-height="560"
                      style="width: 100%">
                    <el-table-column
                        label="序号"
                        type="index"
                        width="50">
                    </el-table-column>
                    <el-table-column prop="year" label="年份"width="60px"></el-table-column>
                    <el-table-column prop="province" label="省份" width="90px"></el-table-column>
                    <el-table-column prop="city" label="地市" width="90px"></el-table-column>
                    <el-table-column prop="scenesName" label="渠道" width="90px"></el-table-column>
                    <el-table-column prop="scenesSubcategory" label="二级分类" width="90px"></el-table-column>
                    <el-table-column prop="agentName" label="经销商" width="150px" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="contractId" label="经销商合同" width="120px"></el-table-column>
                    <el-table-column prop="customerName" label="用户名称" width="180px"></el-table-column>
                    <el-table-column prop="incomeTarget" label="预计目标收入(万元)" width="100px"></el-table-column>
                    <el-table-column prop="facingyewuyuan" label="业务员" width="90px"></el-table-column>
                    <el-table-column label="经销商类型" width="90px">
                      <template slot-scope="scope">
                        {{ formatAgentLevel(scope.row.agentLevel) }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="department" label="科室/院系" width="90px"></el-table-column>
                    <el-table-column label="超低温&低温&冻干机" width="90px">
                        <template slot-scope="scope">
                            {{ scope.row.industryCode && scope.row.industryCode.includes('C1') ? '已签约' : '未签约' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="疫苗网" width="90px">
                      <template slot-scope="scope">
                        {{ scope.row.industryCode && scope.row.industryCode.includes('C2') ? '已签约' : '未签约' }}
                      </template>
                    </el-table-column>
                    <el-table-column label="数智医疗" width="90px">
                      <template slot-scope="scope">
                        {{ scope.row.industryCode && scope.row.industryCode.includes('C3') ? '已签约' : '未签约' }}
                      </template>
                    </el-table-column>
                    <el-table-column label="数智科研" width="90px">
                      <template slot-scope="scope">
                        {{ scope.row.industryCode && scope.row.industryCode.includes('C4') ? '已签约' : '未签约' }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="memo" label="备注" width="110px"></el-table-column>
                    <el-table-column prop="cuname" label="创建人" width="100px" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="cdate" label="创建时间" width="140px" ></el-table-column>
                  </el-table>
                </div>
               <!-- <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                  <h1>附件</h1>
                </div>-->
                <div label="新增附件" class="h-elformWrap-2">
                  <brupload
                      :refid="refid"
                      reftype="目标对阵-新增附件"
                      :uploadflag="false"
                      delflag
                      :tpFlag="true"
                      :showtime="false"
                  >
                  </brupload>
                </div>
                <div class="bannerBox2">
                  <div class="h-row h-mrt1">
                    <div class="h-rowIn">
                      <div class="h-rowBox">
                        <div class="h-rowCon">
                          <div class="h-pieceIn2">
                            <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                            <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                              <h1>审核信息</h1>
                            </div>
                            <div class="h-pieceCon2 ">
                              <div class="h-formLine weekplandetail11" style="position: relative;">
                                <el-form :inline="true" :model="delData">
                                  <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                                style="width: 100%!important;">
                                    <el-input
                                        v-model="delData.auditMind2"
                                        placeholder="请输入"></el-input>
                                  </el-form-item>
                                </el-form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="text-align: center;margin-top: 0.3rem">
                  <el-button class="h-btn h-bBtn h-bgwhite" @click="goBack"> 返回 </el-button>

                  <el-button class="h-btn h-bBtn h-bgred" @click="pass(2)" v-if="!daquflag">驳回</el-button>
                  <el-button class="h-btn h-bBtn h-bggreen" @click="pass(1)" v-if="!daquflag">通过</el-button>

                  <el-button class="h-btn h-bBtn h-bgred" @click="daquPass(2)" v-if="daquflag">大区驳回</el-button>
                  <el-button class="h-btn h-bBtn h-bggreen" @click="daquPass(1)" v-if="daquflag">大区通过</el-button>

                  <el-button class="h-btn h-bBtn" @click="viewpress">
                    审批跟踪
                  </el-button>
                </div>
                <viewhistory :visible.sync="showhistory" v-if="showhistory"
                             :id="instid"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import agentCopyService from "../../../api/loud/agent/agentCopyService";

export default {
  data() {
    return {
      q: {
        customerName: '',
        agentName: '',
        scenesName: '',
        areaName: '',
        pageNo: 1,
        pageSize: 10,
        total: 0,
        year: '',
      },
      delData: [],
      qyearList: [],
      quyuList: [],
      qudaoList: [],
      size: '',
      tableData: [],
      refid:null,
      //表格
      multipleSelection: [],
      // 展开折叠筛选
      isScreen: false,
      uploaddownexcelflag: false,
      daquflag:false,
      newDialog: false,
      editDialog: false,
      yearList: [new Date().getFullYear(), new Date().getFullYear() + 1],
      weekList: [],
      authTypeListEdit: [],
      disEdit: false,
      workList: [],
      AuthoCheck: '',
      authTypeList: [],
      userList: [0],
      weekPlanList: [],
      groupList: [],
      groupArr: [],
      titleDig: "",
      iscontract : '',//是否维护了合同

      shenglist: [],// 省份list
      cityList: [],      //城市list
      customerNameList: [], //用户单位list
      agentList: [],      //签约经销商
      showhistory:false,
      instid:"",
    }

  },

  methods: {

    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectPageAll() {
      console.log("12312312312", this.q)
      ss.grabOrderApi.selectPageTargetAgainstUser(this.q).then(res => {
        console.log(res)
        console.log("total", res.total)
        this.tableData = res.records
        this.q.total = res.total
        console.log("table", this.tableData)
      })
    },
    //
    uploaddownexcelflagbtn() {
      this.uploaddownexcelflag = true;
    },
    uploadExcelFilecallback(rd) {
      this.$msg.msgs(rd.msg);
      this.selectPageAll()
    },
    changeTop(val){
      console.log("changeTop",val);
    },
    pass(aaa){
      let query = {
        taskid:this.$route.query.taskid,
        aaa:aaa,
        auditMind2:this.delData.auditMind2,
        usercode: this.delData.usercode,
        instid:this.$route.query.instid,
        ywid:this.$route.query.ywid,
        list:this.tableData,
        updateAndadd: "add",
      }
      ss.grabOrderApi.updateAndAddPass(query).then(res => {
        this.$msg.alerts("提交成功！", () => {
          //刷新右上角的代办个数
          this.$store.dispatch("searchTasktotal")
          //跳转回系统的代办列表
          this.$router.push({
            path: '/personal/dealCenter'
          })
        })
      })
    },

    viewpress() {
      this.showhistory = true;
    },
    goBack() {
      this.$router.push({
        path: '/agent/agentCopy'
      })
    },
    loadArea(i) {
      let proSelect = {
        pcode: 0,
        level: 1,
      }

      console.log(proSelect)
      ss.Dictservice.arealist(proSelect).then(rd => {
        this.shenglist = rd;
      })
    },
    // 省份选择器
    handleItemChange1(o, salesman, city) {
      if(o == ""){
        return
      }
      this.city = city;
      if (city == null) {
        this.city = null;
      }
      this.add.provinceList = _.find(this.shenglist, {code: o});
      ss.Dictservice.getCity({code: o}).then(rd => {
        this.cityList = rd.zlist;
      })
    },
    handleItemChange2(o) {
      this.add.city = o;
    },
    //获取用户单位
    showGroupList(value) {
      if(value == "" ){
        return;
      }
      ss.MuBiao.getUserLoud(value).then(res => {
        console.log(res)
        this.customerNameList = res
        this.add.customerCode = res[0].deptId
      })
    },
    //签约经销商
    showComList(value) {
      if(value == "" ){
        return;
      }
      ss.netApi.selectByUserNameLoud(value).then(res => {
        console.log(res)
        this.agentList = res.obj
        if(this.agentList.length = 1){
          this.add.agentCode = res.obj[0].usercode;
        }

      })
    },
    getqWeeksBySelectYear() {
      this.getqWeeks(this.q.year, 1);
    },
    // 展开折叠
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    exit() {
      this.closeDialog()
    },
    getQuyuList() {
      ss.Dictservice.listbycategory("YLRegion").then(rd => {
        this.quyuList = rd;
      })
    },
    getQudaoList() {
      ss.Dictservice.listbycategory("sales_region").then(rd => {
        this.qudaoList = rd;
      })
    },
    getWeeks(y) {
      ss.MuBiao.getWeekList({year: y}).then(rd => {
        this.weekList = rd;
      })
    },
    getWeeksBySelectYear() {
      this.getWeeks(this.add.year);
      ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
        this.addlianqunList = rd;
      })
    },
    getListByInstid(instid) {
      var query = {
        instid:instid,
      }
      ss.grabOrderApi.getListByInstid(query).then(rd => {
        console.log("rd",rd);
        console.log("refid",rd.msg[0].refid);
        this.tableData = rd.msg;
        this.refid = rd.msg[0].refid;
      })
    },
    formatAgentLevel(agentLevel) {
        if (agentLevel === 1) {
            return '一级经销商';
        } else if (agentLevel === 2) {
            return '二级经销商';
        } else if (agentLevel === 3) {
            return '专营商';
        }else if (agentLevel === 4) {
            return '直单用户';
        }else if (agentLevel === 5) {
            return '分销商3.0';
        }else if (agentLevel === 6) {
            return '地市直营商';
        }else {
            return agentLevel; // 其余情况显示原始值
        }
    },

  },
  watch: {
    'add.customerName': {
      deep: true,
      handler: function (newVal, oldVal) {
        this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
        var len = this.groupList.length;//groupList
        var arr = [];
        for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
          if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
            arr.push({
              value: this.groupList[i].name,
              id: this.groupList[i].id
            })
          }
        }
        this.groupArr = arr
      }
    },
  },
  created() {
      this.getListByInstid(this.$route.query.instid);
      this.instid = this.$route.query.instid;
  },
  components: {
    uploaddownexcel,
  },
}
</script>
<style scoped>
/deep/ .h-formbLine .el-form-item__label {
  width: 100px;
}


/deep/ .h-formbLine .el-form-item__content {
  width: 150px;
}
</style>
